// removed by extract-text-webpack-plugin
module.exports = {"app":"app__2Qjdi","textPadding":"textPadding__3EkNF"};


//////////////////
// WEBPACK FOOTER
// ./components/App.css
// module id = XX25
// module chunks = 8